import {MovieLayer} from 'common/src/modules/movie/movieLayers.types';
import {Timestamped} from 'common/src/modules/movie/movieRendering';

function layerTransformToDOMMatrix(transform: Timestamped<MovieLayer['tr']>): DOMMatrix {
  const {
    an: [anchorX, anchorY, anchorZ],
    p,
    px,
    py,
    pz,
    s: [scaleW, scaleH, scaleZ] = [0, 0, 0],
    rx = 0,
    ry = 0,
    rz = 0,
  } = transform;

  const translateX = px ?? p?.[0] ?? 0,
    translateY = py ?? p?.[1] ?? 0,
    translateZ = pz ?? p?.[2] ?? 0;

  return new DOMMatrix()
    .translateSelf(translateX, translateY, -translateZ)
    .rotateSelf(-(rx / Math.PI) * 180, 0, 0)
    .rotateSelf(0, -(ry / Math.PI) * 180, 0)
    .rotateSelf(0, 0, (rz / Math.PI) * 180)
    .skewXSelf(0)
    .skewYSelf(0)
    .scaleSelf(scaleW, scaleH, scaleZ)
    .translateSelf(-anchorX, -anchorY, anchorZ);
}

export default layerTransformToDOMMatrix;
